/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type WebhookVersion = typeof WebhookVersion[keyof typeof WebhookVersion];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookVersion = {
  VERSION_1: 'VERSION_1',
  VERSION_1_1: 'VERSION_1_1',
  VERSION_1_2: 'VERSION_1_2',
} as const;
